<template>
  <div v-if="product" class="top-header">     
    <div class="bg-white py-6 shadow">
    <b-container>
      <b-row>
        <b-col cols="12" md="12" lg="8">
          <div :class="{'modal-slider': show_modal}">
            <div class="modal-close" v-if="show_modal" @click="showModal(false)"><b-icon icon="X"></b-icon></div>
            <div class="slider-block">              
          <b-carousel v-if="product.colors"
        id="carousel-no-animation"
        :controls="imagesfromproduct.length > 1"
        :indicators="imagesfromproduct.length > 1"
        :interval="0"
      >
      
        <b-carousel-slide
          v-for="image in imagesfromproduct"
          :key="image.id"
        >
        <img slot="img" class="d-block img-fluid w-100"
             :src="'/'+image.path" alt="image slot" @click="showModal(true)">  
      </b-carousel-slide>

      </b-carousel>
    </div>
  </div>
        </b-col>
        <b-col>
            <h1 class="mt-3 mt-lg-0">{{product.name}}</h1>
            <hr>
            <div class="colors-list" >
          <div class="d-inline-block p-2 colors-list-elem" @click="changeCurentColor(index)" v-for="(color, index) in product.colors" :key="color.id" :class="{active: index==current_color && !show_interior}">            
            <div class="colors-list-color d-inline-block align-middle border" :style="{backgroundColor:color.color}"></div>
            <div class="d-inline-block align-middle ml-2">{{color.name}}</div> 
          </div>
        </div>
        <hr v-if="product.images_interior.length>0">
        <div class="colors-list d-flex justify-content-between" v-if="product.images_interior.length>0 || product.link_video">
          <div class="p-2 colors-list-elem border" v-if="product.images_interior.length>0" @click="showInterior()" :class="{active: show_interior}">            
            <div class="d-inline-block align-middle">Фото салона</div> 
          </div>
          <a class="p-2 colors-list-elem shadow-green border text-dark" target="_blank" v-if="product.link_video" :href="product.link_video">            
            <div class="d-inline-block align-middle">Видеообзор</div> 
          </a>
        </div>
            <hr>
            <div class="my-2 ql-editor ql-viewer" style="padding-bottom: 90px;" v-html="product.description"></div>
            <h4 class="price-big-card">
              <div style="line-height: 1.1;">
            <b>{{ pricefromproduct }} </b> <span class="ql-editor  ql-viewer ql-inline" v-html="settings.valutacatalog"></span>
          </div>  
          <div style="line-height: 1.1;">
            <div class="formula mt-2">
              <span class="pointer" :style="toast?'color: #28a745;':''" @click="showToastFormula()">
                {{priceRubFormat(priceRub())}} <small>РУБ</small> 
              </span>
              </div>
              <b-toast class="position-absolute bg-white" :id="'toast'" title="Расчет цены за комплектацию: " static auto-hide @hide="hideToastFormula()">
                {{ pricefromproduct }}
                <span>{{settings.currency_type}}</span> 
                * {{(1/settings[settings.currency_type]).toFixed(2)}} &#8381; 
                ({{(1/settings[settings.currency_type]).toFixed(2)}} - стоимость юаня на учетную дату)
              </b-toast>  
          </div>
            </h4> 
        </b-col>
      </b-row>
    </b-container> 
  </div>
  <div class="py-3 bg-custom" v-if="product.full_description">
    <b-container> 
    <div class="py-3 px-md-4 px-3 bg-white my-5 shadow" >
        <div class="my-2 ql-editor ql-viewer" v-html="product.full_description" v-if="show_full_desc"></div> 
        <div class="my-2 ql-editor ql-viewer" v-html="full_cut_desc" v-else></div> 
        <div v-if="product.full_description != full_cut_desc" class="text-right">
          <div v-if="show_full_desc">
          <b-button variant="link" @click="showFullDesc()">скрыть</b-button>          
          </div>
          <div v-else>
          <b-button variant="link" @click="showFullDesc()">показать больше</b-button>          
          </div>
        </div>
        
      </div> 
    </b-container>   
  </div>
    <b-container> 
       
      <div v-if="product.configurations.length>0" class="my-5 pt-4">
        <h2 class="text-center mb-4"><b>КОМПЛЕКТАЦИИ</b></h2>                
        <b-row>
          <b-col cols="12" md="6" lg="4" v-for="(configuration, index) in product.configurations" :key="configuration.id" class="mb-5">
            <hr>
            <h4 class="px-3">
              <b>{{configuration.name}}</b>
            </h4>
            <hr>
            <div class="my-2 ql-editor ql-viewer" v-html="configuration.description"></div>
            <h4 class="px-3 price-big-card position-static my-3 w-100">
              <div style="line-height: 1.1;">
            <b>{{ priceformat(configuration.price) }} </b> <span class="ql-editor  ql-viewer ql-inline" v-html="settings.valutacatalog"></span>
          </div>  
          <div style="line-height: 1.1;">
            <div class="formula mt-2">
              <span class="pointer" :style="configuration.toast1?'color: #28a745;':''" @click="showToastFormula(1,configuration.id,index)">
                {{priceRubFormat(priceRub(configuration.price))}} <small>РУБ</small> 
              </span>
               + 
              <span class="pointer" :style="configuration.toast2?'color: #28a745;':''" @click="showToastFormula(2,configuration.id,index)">
                {{priceRubFormat(priceRub(configuration.price)*0.48)}} <small>РУБ</small>
              </span> 
               =
              <span class="pointer" :style="configuration.toast3?'color: #28a745;':''" @click="showToastFormula(3,configuration.id,index)">
                 {{priceRubFormat(priceRub(configuration.price)*1.48)}} 
                 <small>РУБ</small>
              </span>
            </div>            
            <b-toast :id="'toast_'+1+'_'+ configuration.id" title="Расчет цены за комплектацию: " static auto-hide @hide="hideToastFormula(1,index)">
                {{priceRubFormat(configuration.price)}} 
                <span>{{settings.currency_type}}</span> 
                * {{(1/settings[settings.currency_type]).toFixed(2)}} &#8381; 
                ({{(1/settings[settings.currency_type]).toFixed(2)}} - стоимость юаня на учетную дату)
            </b-toast>
            <b-toast :id="'toast_'+2+'_'+ configuration.id" title="Расчет таможенных платежей:" static auto-hide @hide="hideToastFormula(2,index)">
                 {{priceRubFormat(priceRub(configuration.price))}} &#8381; * 48%
            </b-toast>
            <b-toast body-class="d-none" :id="'toast_'+3+'_'+ configuration.id" title="Цена электромобиля в России" static auto-hide @hide="hideToastFormula(3,index)">
            </b-toast>
          </div>         
            </h4>  
          </b-col>
        </b-row>     
      </div>    
    </b-container>     
    <div class="bg-white shadow mt-5" v-if="product.link_frame||product.link_body_frame">
    <b-container class="p-0 p-md-3">  
      <div v-if="product.link_frame">
        <h2 class="text-center py-3 m-0"><b>САЛОН 360&#176;</b></h2>
        <div style="overflow-x: auto; max-width: 100%">
          <iframe width="100%" class="mb-5 frame-360" :src="product.link_frame"></iframe> 
        </div>
      </div>
      <div v-if="product.link_body_frame">
        <h2 class="text-center py-3 m-0"><b>КУЗОВ 360&#176;</b></h2>
        <div class="frame-body-360-container">
          <iframe width="100%" class="mb-5 frame-body-360" :src="product.link_body_frame"></iframe> 
        </div>
      </div>
    </b-container>
      </div> 
    </div>   
 
</template>
<script>
import Authentication from "@/components/pages/Authentication";
export default {
  props:['settings'],
    data() {
    return {
      product:null, 
      current_color: 0,
      show_modal:false,
      show_full_desc: false,
      show_interior:false, 
      toast:false
    };
  },
  computed:{
    full_cut_desc(){
      const elem = document.createElement("div");
      elem.innerHTML = this.product.full_description
      while (elem.children.length > 1) {
        elem.removeChild(elem.lastChild);
      }
      return elem.innerHTML
    },
    imagesfromproduct(){     
      if(this.show_interior){
        if(this.product.images_interior.length>0){
          return this.product.images_interior    
        }else{
          return false
        }   
      }else{
        if(this.product.colors.length>0){
          return this.product.colors[this.current_color].images    
        }else{
          return false
        }   
      }
    },
    pricefromproduct(){
      if(this.product.configurations.length==0){
        return 0
      }
      return  this.priceformat(Math.min(...this.product.configurations.map(el=>el.price)))
    },
  },
  created() {
    this.getProduct();
  },
  methods: {  
    showToastFormula( toast_number ,id, index){
      if(toast_number){
        this.$bvToast.show('toast_'+toast_number+'_' + id)
        this.$set(this.product.configurations[index],'toast'+toast_number, true)   
      }else{
        this.$bvToast.show('toast')
        this.toast = true
      }
    },
    hideToastFormula(toast_number,index){
      if(toast_number){
        this.$set(this.product.configurations[index],'toast'+toast_number, false)
      }else{
        this.toast = false
      }
    },
    priceRubFormat(price){
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },
    priceRub(price_val){
      let price = price_val?price_val: this.product.configurations.length==0?0:Math.min(...this.product.configurations.map(el=>el.price))
      return Authentication.priceRub(price,this.settings[this.settings.currency_type])
    },
    showInterior(){
      this.show_interior=true
    },
    showFullDesc(){
      this.show_full_desc = !this.show_full_desc
    },
    priceformat(price){
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    },  
    changeCurentColor(index){
      this.show_interior=false
      this.current_color = index
    },
    showModal(show){
      this.show_modal = show
    },
    async getProduct() {
      let { data } = await Authentication.sendRequestNotAuth(
        this,
        "/api/v1/product",
        "post",
        { id: this.$route.params.id }
      );
      if (data) {
        this.product = data;
      }
    },
  },
};
</script>
<style lang="scss">  
.bg-custom{
  background: radial-gradient(#ffffff 50%, #797979 100%);
}
 .colors-list{
  .active{
      border: 2px solid $color2;
      &.border{
        border: 2px solid $color2 !important;
        box-shadow: none;
      }
   }
  &-color{
    width: 20px;
    height: 20px;  
 }  
 &-elem{
  cursor: pointer;
 }
}
.price-big-card{
  border-top: 2px solid $color2;
  border-bottom: 2px solid $color2;
  text-align: center;
  padding: 10px;
  position: absolute;
  width:calc(100% - 30px);
  bottom: 0;
  margin: 0;
}
.frame-360{
  height: 99vw;
  max-height: 600px;
}
.frame-body-360{
  height: 99vw;
  max-height: 600px;
}

.frame-body-360-container{
  overflow-x: auto; 
  max-width: 100%
}

.slider-block{
    cursor: pointer;
  }
.modal-slider{
  position: fixed;
  top:0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000000cc;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal-close{
      font-size: 50px;
      cursor: pointer;
      color:#fff;
      line-height: 1;
      background-color: rgba($color1, 0.8);
      z-index: 1002;
      position: absolute;
      top:10px;
      right: 30px;
    }
  .slider-block{
    position: relative;    
    max-width: 1200px;
  }
}  
@media (max-width: 767px) {
  .frame-360{
    min-width: 480px;
  }
  .frame-body-360{
    margin-top: -100px;
    margin-left: -34%;
    width: 168%;
    height: 500px;
    &-container{
      overflow: hidden;
      width: 100%;
      height: 500px;
    }
  }
  .modal-slider .modal-close{
    right: 5px;
  }
}

</style>